// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarClientesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/clientes/migrar-todas
 * (controllers/migration/clientes.php::migrar_todas).
 *
 * Um unico campo, OBRIGATORIO: a franquia cujos clientes vao migrar. A carga
 * varre as paginas do export sozinha (cursor de ID) — o operador nao pagina.
 *
 * Tipo ESTRITO pelo motivo de sempre: o id da unidade tem 19 digitos e e
 * MAIOR que 2^53 — um numero JSON aqui ja chegaria corrompido do navegador
 * (armadilha A1).
 */
import { registerContract } from './validate'

export interface Migration_MigrarClientesInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_MigrarClientesInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
